<div class="country">
  {{ label$ | async }}
</div>
